import { render } from "./DocumentExplorer.vue?vue&type=template&id=ed7a5312&scoped=true&ts=true"
import script from "./DocumentExplorer.vue?vue&type=script&lang=ts"
export * from "./DocumentExplorer.vue?vue&type=script&lang=ts"

import "./DocumentExplorer.vue?vue&type=style&index=0&id=ed7a5312&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7a5312"]])

export default __exports__